import { useContext } from 'react'
import { AppContext } from '../components/App'
export default () => useContext(AppContext)
